import { LocationTypes } from "Types/LocationTypes";

export const getLocationCurrency = (location: LocationTypes[]): string => {
    return location[0].currency;
};
